<!-- [style]="colorStyles()" -->
<div
  class="h-full w-full rounded-2xl border-l-6 bg-white p-4 hover:cursor-pointer"
  (click)="clicked()"
  [class.border-success]="
    !showProgress() || instructionConfirmation().status == 'submitted'
  "
  [class.border-warning]="
    showProgress() && instructionConfirmation().status != 'submitted'
  "
>
  <div class="flex w-full flex-row">
    <h1 class="flex-grow truncate text-2xl text-ellipsis">
      {{ instruction().title }}
    </h1>

    <div class="flex flex-none flex-col items-end">
      <span class="text-gray-400">
        @if (instructionConfirmation().status == "submitted") {
          {{ "instruction.instruction-item.confirmed" | translate }}
          {{
            instructionConfirmation().modified
              | date: ("common.dateTimeFormat" | translate)
          }}
        } @else {
          {{ "instruction.instruction-item.since" | translate }}
          {{
            instructionConfirmation().creation
              | date: ("common.dateTimeFormat" | translate)
          }}
        }
      </span>

      <span
        [class.text-gray-400]="deadlineStatus() == 'none'"
        [class.text-warning]="deadlineStatus() == 'soon'"
        [class.text-error]="deadlineStatus() == 'overdue'"
        [class.font-bold]="deadlineStatus() != 'none'"
      >
        @if (
          instructionConfirmation().deadline &&
          instructionConfirmation().status != "submitted"
        ) {
          {{ "instruction.instruction-item.deadline" | translate }}
          {{
            instructionConfirmation().deadline
              | date: ("common.dateTimeFormat" | translate)
          }}
        }
      </span>
    </div>
  </div>
  <div class="badge badge-outline badge-primary my-2">
    {{ instruction().mode }}
  </div>

  <p class="whitespace-pre-line text-gray-500">
    {{ instruction().description }}
  </p>

  @if (showProgress()) {
    @if (progress(); as p) {
      <div class="mt-4 mb-2">
        <progress
          class="progress"
          [class.progress-success]="
            instructionConfirmation().status == 'submitted'
          "
          [class.progress-warning]="
            instructionConfirmation().status != 'submitted'
          "
          [value]="p.confirmedChapters"
          [max]="p.totalChapters"
        ></progress>
        <div class="flex flex-row justify-between text-sm opacity-60">
          <span>
            {{
              "instruction-details.chapters.confirmed-percentage"
                | translate: { percentage: progressPercentage() }
            }} </span
          ><span>
            {{
              "instruction-details.chapters.confirmed-chapters"
                | translate
                  : {
                      chapters: p.totalChapters,
                      confirmedChapters: p.confirmedChapters,
                    }
            }}
          </span>
        </div>
      </div>
    }
  }
  <div class="flex flex-row justify-end">
    <button class="btn btn-primary" (click)="clicked()">
      {{ "common.open" | translate }}
    </button>
  </div>
</div>
